import * as React from 'react';
import styled from 'styled-components';
import { KCFColor } from 'styles/themes/KCFColor';
import { hexToRGBA } from 'utils/color';

const ValidationSummaryContainer = styled.div`
    padding: 1rem;
    border-left: 5px solid ${KCFColor.red1};
    background-color: ${hexToRGBA(KCFColor.red1, 0.1)};
`;

export type ValidationSummaryProps = {
    children?: React.ReactNode;
    className?: string;
};

export function ValidationSummary({ children, className }: ValidationSummaryProps) {
    return (
        <ValidationSummaryContainer role="alert" className={className}>
            {children}
        </ValidationSummaryContainer>
    );
}
